import { getTrackedInfo } from './trackingAttributesGenerator';

export default ({ locale, urlParams }) => {
	window.DDC.getTrackedInfo = (type) =>
		getTrackedInfo(locale, urlParams, type);
};
